<template>
  <div :class="{ 'single-file-upload--invalid': invalid }">
    <FileUpload
        :id="id"
        customUpload
        :maxFileSize="MAX_FILE_SIZE"
        @select="emit('select', $event)"
        @remove="emit('remove')"
    >
      <template #header="{ chooseCallback }">
        <Button @click="chooseCallback()" icon="pi pi-plus" :label="t('SELECT_FILE')" outlined />
      </template>
      <template #content="{ files, removeFileCallback }">
        <div v-if="files[0]" class="d-flex">
          <div class="flex-grow-1">
            <span class="text-break">{{ files[0].name }}</span>
          </div>
          <Button
              v-tooltip="t('REMOVE')"
              icon="pi pi-times"
              text
              rounded
              severity="danger"
              :aria-label="t('REMOVE')"
              @click="removeFileCallback(0)"
          />
        </div>
      </template>
      <template #empty>
        <span>{{ t('FILE_TIP') }}</span>
      </template>
    </FileUpload>
    <small v-if="invalid" class="text-danger">{{ t('ERRORS.FIELD_IS_REQUIRED') }}</small>
  </div>
</template>

<script setup lang="ts">
import type {FileUploadSelectEvent} from "primevue/fileupload";
import {useI18n} from "vue-i18n";

const MAX_FILE_SIZE = 20 * 1024 * 1024;

const {t} = useI18n();

defineProps<{
  id?: string;
  invalid?: boolean;
}>();

const emit = defineEmits<{
  select: [event: FileUploadSelectEvent];
  remove: [];
}>();
</script>

<style scoped>
.single-file-upload--invalid :deep(.p-fileupload) {
  border-color: var(--p-inputtext-invalid-placeholder-color);
}
</style>
